import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import inactivityMiddleware from './middlewares/inactivityMiddleware';
import rootReducer from './reducers';
import * as schema from './schema';

const middleware = applyMiddleware(
	thunk.withExtraArgument({ schema }),
	inactivityMiddleware,
);

const devTools =
	typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
		? window.__REDUX_DEVTOOLS_EXTENSION__()
		: compose;

const store = createStore(rootReducer, compose(middleware, devTools));

export default store;



// WEBPACK FOOTER //
// ./src/store.js